import { Category } from "../types";
import processorsImage from "../images/products/processor.png";
import graphicsCardsImage from "../images/products/graphic card.png";
import storageSolutionsImage from "../images/products/storage solutions.png";
import motherboardsImage from "../images/products/motherboard.png";
import peripheralsImage from "../images/products/peripherals.png";
import coolingSolutionsImage from "../images/products/cooling .png";
import { products } from "./products";

// Calculate product count for each category
const getProductCount = (categoryId: string) => {
  return products.filter(product => product.category === categoryId).length;
};

export const categories: Category[] = [
  {
    id: "processors",
    name: "Processors",
    image: processorsImage,
    description: "High-performance CPUs from Intel and AMD",
    productCount: getProductCount("processors"),
    discount: "Up to 25% OFF",
  },
  {
    id: "graphics-cards",
    name: "Graphics Cards",
    image: graphicsCardsImage,
    description: "Latest GPUs for gaming and professional work",
    productCount: getProductCount("graphics-cards"),
    discount: "Up to 20% OFF",
  },
  {
    id: "storage",
    name: "Storage Solutions",
    image: storageSolutionsImage,
    description: "SSDs and HDDs for every storage need",
    productCount: getProductCount("storage"),
    discount: "Up to 20% OFF",
  },
  {
    id: "motherboards",
    name: "Motherboards",
    image: motherboardsImage,
    description: "Premium motherboards for your build",
    productCount: getProductCount("motherboards"),
    discount: "Up to 15% OFF",
  },
  {
    id: "peripherals",
    name: "Peripherals",
    image: peripheralsImage,
    description: "Keyboards, mice, and gaming accessories",
    productCount: getProductCount("peripherals"),
    discount: "Up to 15% OFF",
  },
  {
    id: "cooling",
    name: "Cooling Solutions",
    image: coolingSolutionsImage,
    description: "CPU coolers and case fans for optimal performance",
    productCount: getProductCount("cooling"),
    discount: "Up to 20% OFF",
  },
];